import styled from 'styled-components';
// template components
import DescriptionList from '@nmx/template/dist/componentLibrary/components/DescriptionList';

// eslint-disable-next-line import/prefer-default-export
export const DescriptionListStyled = styled(DescriptionList)`
  margin-left: 0;
  padding-left: 0;
`;
